import React from 'react';
import { Box, useMediaQuery } from '@mui/material';
import { VIRTUAL_GUARD } from 'utils/route-constants';
import { useLocation } from 'react-router-dom';
import Profile from './Profile';
import MobileSection from './MobileSection';
import ScannerConfiguration from './ScannerConfiguration';
import { connect } from 'react-redux';

const HeaderContent = ({ userData }) => {
    const matchesXs = useMediaQuery(theme => theme.breakpoints.down('md'));
    const location = useLocation();

    const isVirtualGuardRoute = location.pathname === VIRTUAL_GUARD;
    const isOperatorVirtualGuard =
        userData?.role === 'operator' && userData?.type === 'virtual_guard';

    return (
        <>
            {!matchesXs && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {isVirtualGuardRoute && isOperatorVirtualGuard && (
                        <ScannerConfiguration />
                    )}
                    <Profile />
                </Box>
            )}

            {matchesXs && <MobileSection />}
        </>
    );
};

const mapStateToProps = ({ user }) => {
    const { userData } = user;
    return { userData };
};

export default connect(mapStateToProps, {})(HeaderContent);
